var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1417 24.6562C67.5667 34.6901 54.7881 41.6753 46.793 42.8759",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6892 14.2628C39.1161 6.4768 30.4875 46.7891 43.2579 54.2637",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1816 17.5C97.3574 24.464 92.887 35.2817 87.615 46.7815",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7734 39.623C95.0307 74.1369 45.1719 81.5812 45.1719 50.8805",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1333 49.7083C70.2651 48.7423 69.9931 48.0015 69.8438 47.1055",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0781 50.0344C61.0781 49.1664 61.0781 48.2997 61.0781 47.4316",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5488 112.339C18.5488 100.633 26.1374 72.9143 52.1767 74.1906C59.4304 74.5462 61.1559 114.4 65.9679 112.339C74.3886 108.732 71.6116 82.6442 78.1452 72.8599C109.457 71.1906 109.775 110.735 109.775 116.731",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1657 88.0994C92.687 82.4595 85.7843 74.8931 79.2578 74.1094",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9873 75.4102C44.2834 80.0939 40.9382 87.0697 38.0273 94.9312",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2715 113.151C28.4371 107.309 28.8373 99.8559 34.4829 96.4505C50.3563 86.8761 48.3269 117.993 40.6717 112.496",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2173 88.1123C103.574 87.7043 91.2016 97.3369 93.5151 88.7627",
    stroke: "white",
    strokeWidth: 2.91723,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7642 105.438C93.8227 104.93 90.7765 106.63 87.0508 106.97",
    stroke: "white",
    strokeWidth: 5.83446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/doctor-icon.9e0a2f46ee9bee13054c157cfca94c2b.svg";
export { ForwardRef as ReactComponent };